import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export class TeamEmailService extends BaseService {
    protected get resourceName(): string {
        return 'crm/team-email';
    }

    /// O endereço que a equipe põe em cópia; null com a integração desligada.
    public async address(): Promise<AxiosResponse<{ data: { address?: string | null } }>> {
        return await this.get('');
    }
}
